import { IncomingMessage } from 'http';

import { fechFromBPartsApi } from '../utils';

const fetchProductUniqueVehicle = async (
  {
    locale,
    slug,
    shipping_location,
    detailed_prices,
  }: {
    locale: string;
    slug: string;
    shipping_location?: string;
    detailed_prices?: boolean;
  },
  req?: IncomingMessage
) => {
  const queries = [];

  if (shipping_location) {
    queries.push(`shipping_location=${encodeURI(shipping_location)}`);
  }

  if (detailed_prices) {
    queries.push(`detailed_prices=true`);
  }

  const data = await fechFromBPartsApi(
    `/${locale}/shop/products/unique_vehicle/${encodeURI(slug)}${
      queries.length ? `?${queries.join('&')}` : ''
    }`,
    {
      headers: req ? new Headers(req.headers) : undefined,
      credentials: 'include',
    }
  );
  return data.json();
};

export default fetchProductUniqueVehicle;
